import { removeUndefined } from '../../utils/objects.js';
import BaseField from './BaseField.js';
class DateField extends BaseField {
    default;
    constructor(data = {}) {
        super({
            ...data,
            example: (data.example ?? data.default ?? new Date(0)).toISOString(),
        });
        this.default = data.default;
        this.proto.type = 'string';
    }
    toSchema(transport, options) {
        return removeUndefined({
            ...super.toSchema(transport, options),
            type: 'string',
            format: 'date-time',
            default: this.default,
        });
    }
    toJSON(input, _target) {
        return input.toJSON();
    }
    fromJSON(input) {
        return input === undefined ? input : new Date(input);
    }
}
export default DateField;
//# sourceMappingURL=DateField.js.map